import { Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import React, { useCallback, useState } from "react";

function CheckText({ name, onChange, onBlur }) {
  const [value, setValue] = useState("");
  const handleValueChanged = useCallback(
    (event) => {
      setValue(event.target.value);
      if (onChange instanceof Function) onChange(event.target.value);
    },
    [onChange]
  );

  const [enabled, setEnabled] = useState(false);
  const handleEnabledChanged = useCallback(
    (event) => {
      setEnabled(event.target.checked);
      if (!event.target.checked) handleValueChanged({ target: { value: "" } });
    },
    [handleValueChanged]
  );

  return (
    <div className="flex gap-1">
      <FormControlLabel
        className="w-20"
        control={
          <Checkbox
            checked={enabled}
            onChange={handleEnabledChanged}
            color="primary"
          />
        }
        label={name}
      />

      <TextField
        required
        type="text"
        size="small"
        variant="outlined"
        className="flex-1"
        label={name}
        value={value}
        disabled={!enabled}
        onBlur={onBlur}
        onChange={handleValueChanged}
        InputLabelProps={{ shrink: true }}
      />
    </div>
  );
}

export default CheckText;
